import axios from 'axios';
import maxBy from 'lodash/maxBy';
import pickBy from 'lodash/pickBy';
import remove from 'lodash/remove';
import map from 'lodash/map';
import isObject from 'lodash/isObject';
import {
  ADD_EVENT_TO_BETSLIP_FAILURE,
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS,
  BETSLIP_CLOSED,
  BETSLIP_OPENED,
  BETSLIP_SETTINGS_OPENED,
  BETSLIP_SETTINGS_UPDATED,
  PLAY_COUPON_FAILURE,
  PLAY_COUPON_REQUEST,
  PLAY_COUPON_SUCCESS,
  REMOVE_EVENT_FROM_BETSLIP,
  RESET_BETSLIP,
  SAVE_COUPON_FAILURE,
  SAVE_COUPON_REQUEST,
  SAVE_COUPON_SUCCESS,
  SET_BETSLIP_COUPON_COUNT,
  SET_BETSLIP_FROM_LOCAL_STORAGE,
  SET_BETSLIP_MULTIPLIER,
  SET_BETSLIP_SYSTEM,
  TOGGLE_BETSLIP_BANKER,
  VALIDATE_BETSLIP_FAILURE,
  VALIDATE_BETSLIP_REQUEST,
  VALIDATE_BETSLIP_SUCCESS,
  VALIDATE_MBS_STATE,
  BETSLIP_SET_HAS_LIVE_EVENT,
  BETSLIP_BET_DELAY_TIME_DEFAULTS,
  BETSLIP_BET_DELAY_REQUEST_INTERVAL_DEFAULTS,
  BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE,
  SET_MULTIPLE_COUPON_DATA,
  RESET_PLAY_COUPON,
  PLAY_COUPON_UPDATE_PREDICTA
} from 'Store/constants';

import { trackBetSlipViewed } from 'Utils/analytics';
import getDefaultStakeAmount, {
  getDefaultStakeLimits,
  getLastAppliedDefaultStake,
  setLastAppliedDefaultStake,
} from 'Utils/getDefaultStakeAmount';
import ProjectConfig from 'ProjectConfig';
import {
  COUPON_PLAYED,
  COUPON_SBS_RETRY,
  COUPON_TIMEOUT,
  COUPON_WAITING,
  EVENT_FIELD_MAPPING,
  GTA_SPORT_TYPE_NAMING,
  ODD_FIELD_MAPPING,
  OUTRIGHTS,
  SPORTSBOOK,
  COUPON_REJECTED,
} from 'Store/constants/sportTypes';
import errorMessage from './errorMessage';
import { closeModal, openModal } from './modalActions';
import { updateUserBalance } from './authActions';
import { loadStateFromIndexedDB } from 'Utils/manageIndexedDB';
import EnvironmentManager from 'Utils/environmentManager';
import LocalStorage from 'Utils/localStorage';
import { getEventScores } from './eventScoresActions';
import isEmpty from 'lodash/isEmpty';
import { trackBeginCheckoutError } from 'Utils/analytics';
import uuidv4 from 'uuid/v4';
import { cartEvents, cartEventsDetail } from 'Utils/dengageEvents';
import { debounce, omit } from 'lodash';
import { toast } from 'react-toastify';
import ToastTemplate from '../../components/ToastTemplate';
import React from 'react';
import History from 'Store/history';
import { shouldRedirectToLowBalanceFastDeposit } from 'Utils/lowBalanceFastDeposit';
const API_GATEWAY = ProjectConfig.API_GATEWAY;

const BETSLIP_BET_DELAY_TIME = (EnvironmentManager.getParameter('betslip_bet_delay_time') || BETSLIP_BET_DELAY_TIME_DEFAULTS) * 1000;
const BETSLIP_BET_DELAY_REQUEST_INTERVAL = (EnvironmentManager.getParameter('betslip_bet_delay_request_interval') || BETSLIP_BET_DELAY_REQUEST_INTERVAL_DEFAULTS) * 1000;
// const ADD_EVENT_FAIL_TOAST_MESSAGE = EnvironmentManager.getMessageText({ key: 'add_to_betslip_warning_message' });

export const setBetslipFromLocalStorage = () => dispatch => {
  loadStateFromIndexedDB('betSlip', data => {
    dispatch({
      type: SET_BETSLIP_FROM_LOCAL_STORAGE,
      payload: data ? data : {}
    });
    dispatch(syncBetSlipMinStake());
  });
};

export const playCoupon = () => async (dispatch, getState) => {
  if (getState().modalData?.modalNames?.includes('couponPlayLoader')) {
    return;
  }

  const { coupon, tribünEventList, couponDetails } = getState().betSlip;

  if (tribünEventList) {
    if (coupon?.bets.length === tribünEventList.length) {
      const notEqualsData = coupon?.bets.filter(item => !tribünEventList.some(data => data.eventId === item.eventId && data.outcomeNo === item.marketOutcomeNo));
      if (notEqualsData.length > 0)
        coupon.sourceCouponId = null;
    } else {
      coupon.sourceCouponId = null;
    }
  }

  const isMultipleCoupon = coupon.couponCount > 1;
  //const { iddaaTopWinResponse } = getState().betSlip?.validateData?.data;

  const { balance, acceptHigherOdds, acceptLowerOdds, hasInfoPopUpShown  } = getState().auth.data;
  coupon.source = getState().betSlip?.validateData?.data?.source
    || getState().playCoupon?.data?.coupon?.source
    || 'SPORTSBOOK';
  if (coupon?.source === 'RECOMMENDED_COUPON') {
    coupon.sourceCouponId = getState().betSlip?.couponDetails?.[0].sourceCouponId || getState().playCoupon?.data?.couponId;
  }

  try {
    // show 'insufficientFundsModal' if user hasn't got enough money to play coupon
    if (balance < coupon.couponCost) {
      dispatch(closeModal('couponPlayLoader'));
      trackBeginCheckoutError('Bakiyen Yetersiz');
      if (shouldRedirectToLowBalanceFastDeposit(getState)) {
        return History.push({ pathname: '/yetersiz-bakiye', state: { gameType: 'iddaa' } });
      }
      return dispatch(openModal('insufficientFundsModal'));
    }

    dispatch({
      type: PLAY_COUPON_REQUEST
    });
    dispatch(openModal('couponPlayLoader'));
    const obj =  {
      acceptHigherOdds,
      acceptLowerOdds,
    };


    if (coupon?.bets?.length === 1) {
      if (couponDetails[0]?.bets[0].isRecommended === true) {
        coupon.sourceCouponId = coupon?.sourceCouponId;
        coupon.source = 'RECOMMENDED_COUPON';
      }
    }
    const requestBody = Object.assign(coupon, obj);

    //predicta state set için
    dispatch({
      type: PLAY_COUPON_UPDATE_PREDICTA,
      payload: getState().betSlip?.validateData?.data?.calculatedProbability
    });

    const playCouponResponse = await axios.post(API_GATEWAY + ('/iddaa/play/v2'),  requestBody );
    coupon.transactionId = playCouponResponse.data.couponId;


    const profBahistaSwitch = EnvironmentManager.getMessageText({ key: 'prof_bahista_lite_switch' }) === 'true';
    const showRecommended = !!(profBahistaSwitch && playCouponResponse?.data?.recommended);
    let recommendedData = null;

    if (showRecommended) {
      try {
        let response = await axios.get(`${API_GATEWAY}/recommended/coupon?playedCouponId=${playCouponResponse?.data?.couponId}`);
        let data = response?.data?.body;
        coupon.source = data?.source;
        coupon.sourceCouponId = data?.sourceCouponId;
        getState().auth.data.hasInfoPopUpShown = true;
        recommendedData = data;
      } catch (recommendedError) {
        console.warn('Recommended coupon fetch failed', recommendedError);
      }
    }

    dispatch({
      type: PLAY_COUPON_SUCCESS,
      payload: { ...playCouponResponse.data, coupon, recommendedData }
    });

    dispatch({
      type: BETSLIP_SET_HAS_LIVE_EVENT,
      payload: playCouponResponse.data.hasLiveEvent
    });


    const title = playCouponResponse.data.rejectedCouponCount > 0 || playCouponResponse.data.timeoutCouponCount > 0
      ? 'Kuponun Kısmi Olarak Oynandı' : 'Kuponun Başarıyla Oynandı';

    _openPlaySuccessModal({ dispatch, isMultipleCoupon, title,  sourceCoupon: coupon?.source, hasInfoPopUpShown: hasInfoPopUpShown });
    const identifier = uuidv4();

    cartEvents({
      identifier,
      type: 'purchase',
      game_type: 'coupon1',
      total_coupon_amount: coupon.couponCost,
      coupon_id: playCouponResponse.data.couponId,
    });

    couponDetails.forEach(couponDetail => {
      cartEventsDetail({
        identifier,
        event_name: couponDetail.name,
        event_id: couponDetail.eventId,
        sport_type: GTA_SPORT_TYPE_NAMING[couponDetail.sportType],
        market_name: couponDetail.bets[0]?.marketName,
        market_value: couponDetail.bets[0]?.odd,
        coupon_id: playCouponResponse.data.couponId,
        total_coupon_amount: coupon.couponCost,
      });
    });


  } catch (e) {
    const { data = {} } = e.response || {};

    switch (data.code) {
      case 1015: {
        trackBeginCheckoutError('Bakiyen Yetersiz');
        dispatch(closeModal('couponPlayLoader'));
        if (shouldRedirectToLowBalanceFastDeposit(getState)) {
          History.push({ pathname: '/yetersiz-bakiye', state: { gameType: 'iddaa' } });
        } else {
          dispatch(openModal('insufficientFundsModal'));
        }
        break;
      }
      case 1002:
        dispatch({
          type: BETSLIP_SET_HAS_LIVE_EVENT,
          payload: data.extras.hasLiveEvent
        });
        if (data?.extras?.betDelay) {
          return dispatch(checkCouponState({
            couponId: data.extras.couponId,
            betDelay: (data.extras.betDelay * 1000),
            counter: 1,
            coupon: coupon,
            betDelayInterval: (data.extras.betDelayInterval * 1000),
            betDelayTimeout: data.extras.betDelayTimeout
          }));
        }

        return dispatch(checkCouponState({
          couponId: data.extras.couponId,
          betDelay: BETSLIP_BET_DELAY_TIME,
          counter: 1,
          coupon: coupon }));
      case 26150: {
        dispatch(closeModal('couponPlayLoader'));
        dispatch(resetBetSlip());
        dispatch(resetPlayCoupon());
        History.push('/kuponlarim/iddaa/devam-eden');
        break;
      }
      default:
        dispatch({
          type: PLAY_COUPON_FAILURE,
          payload: data || errorMessage
        });
        trackBeginCheckoutError(data.message || errorMessage?.default?.message);
        dispatch(closeModal('couponPlayLoader'));
        dispatch(openModal('playCouponFailureModal'));
    }
  }
};

const checkCouponState = ({
  couponId,
  betDelay = BETSLIP_BET_DELAY_TIME, // ilk check isteğini atmak için kaç sn beklemesi gerektiği (ms olarak)
  counter = 1, // kaç kere deneme yapıldığı
  coupon,
  betDelayInterval = BETSLIP_BET_DELAY_REQUEST_INTERVAL, // ilk istekten sonra kaç sn aralıklarla denemeye devam ediceği (ms olarak)
  betDelayTimeout = 24 // toplamda max kaç deneme yapıcağı
}) => async dispatch => {
  try {
    const delay = new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, betDelay);
    });

    const response = await delay.then(() => axios.get(`${API_GATEWAY}/iddaa/timeout/${couponId}`));
    const isMultipleCoupon = response.data.multiCouponPlayInfos && response.data.multiCouponPlayInfos.length;
    const couponInformation = response.data.couponInformation;

    if (isMultipleCoupon) {
      if (!response.data.showResponse) {
        if (counter < betDelayTimeout) {
          dispatch(checkCouponState({
            couponId: couponId,
            betDelay: betDelayInterval,
            counter: counter + 1,
            coupon: coupon,
            betDelayInterval: betDelayInterval,
            betDelayTimeout: betDelayTimeout }));
        } else {
          trackBeginCheckoutError(EnvironmentManager.getMessageText({ key: 'error_betslip_play_timeout' }));
          dispatch(closeModal('couponPlayLoader'));
          dispatch(openModal('couponPlayWaiting'));
          dispatch(updateUserBalance());
        }
      } else {
        const hasSuccess = response?.data?.multiCouponPlayInfos?.some(e=>e.status === COUPON_PLAYED);
        const hasWaiting = response?.data?.multiCouponPlayInfos?.some(e=>e.status === COUPON_WAITING);
        const hasFail = response?.data?.multiCouponPlayInfos?.some(e=>e.status === COUPON_REJECTED);

        if (hasWaiting) { // bekleyen kupon varsa her zaman waiting modal
          if (coupon) {
            coupon.transactionId = couponId;
          }
          dispatch({
            type: PLAY_COUPON_SUCCESS,
            payload: { coupon }
          });
          trackBeginCheckoutError(EnvironmentManager.getMessageText({ key: 'error_betslip_coupon_waiting_title' }) || 'Kuponların Bekleniyor');
          _openPlaySuccessModal({ dispatch, isMultipleCoupon, icon: 'svgInfoPopularOrange', type: 'waiting', title: EnvironmentManager.getMessageText({ key: 'error_betslip_coupon_waiting_title' }) || 'Kuponların Bekleniyor', couponStatus: response.data.multiCouponPlayInfos });

        } else if (hasSuccess) { // başarılı yada kısmi başarılı
          if (coupon) {
            coupon.transactionId = couponId;
          }
          dispatch({
            type: PLAY_COUPON_SUCCESS,
            payload: { coupon }
          });
          if (hasFail) {
            trackBeginCheckoutError(EnvironmentManager.getMessageText({ key: 'title_betslip_play_partial_success_coupon' }) || 'Kuponların Kısmi Olarak Oynandı');
          }
          const title = hasFail ? EnvironmentManager.getMessageText({ key: 'title_betslip_play_partial_success_coupon' }) || 'Kuponların Kısmi Olarak Oynandı' :    EnvironmentManager.getMessageText({ key: 'title_betslip_play_multi_coupon_success' }) ||  'Kuponların Başarıyla Oynandı';
          _openPlaySuccessModal({ dispatch, isMultipleCoupon, title: title, couponStatus: response.data.multiCouponPlayInfos });

        } else { // hiçbiri oynanamadı modalı
          if (couponInformation && Object.keys(couponInformation).length > 0) {
            dispatch({
              type: PLAY_COUPON_FAILURE,
              payload: couponInformation,
            });
            dispatch(closeModal('couponPlayLoader'));
            dispatch(openModal('playCouponFailureModal'));
          } else {
            trackBeginCheckoutError(EnvironmentManager.getMessageText({ key: 'error_betslip_coupon' }) || 'Kuponların Oynanamadı');
            dispatch(closeModal('couponPlayLoader'));
            dispatch(openModal('playMultipleCouponFailureModal'));
          }

        }
      }

    } else {
      switch (response && response.data && response.data.couponStatus) {
        case COUPON_PLAYED:
          if (coupon) {
            coupon.transactionId = couponId;
          }
          dispatch({
            type: PLAY_COUPON_SUCCESS,
            payload: { coupon }
          });

          _openPlaySuccessModal({ dispatch, isMultipleCoupon: false, title: '', couponStatus: response.data.multiCouponPlayInfos });
          break;
        case COUPON_TIMEOUT:
        case COUPON_WAITING:
        case COUPON_SBS_RETRY:
          {
            if (counter < betDelayTimeout) {
              dispatch(checkCouponState({
                couponId: couponId,
                betDelay: betDelayInterval,
                counter: counter + 1,
                coupon: coupon,
                betDelayInterval: betDelayInterval,
                betDelayTimeout: betDelayTimeout,
              }));
            } else {
              dispatch(closeModal('couponPlayLoader'));
              dispatch(openModal('couponPlayWaiting'));
              dispatch(updateUserBalance());
            }
          }
          break;
        default:
          dispatch(closeModal('couponPlayLoader'));
          dispatch(openModal('couponPlayWaiting'));
          dispatch(updateUserBalance());
      }
    }
  } catch (error) {

    dispatch(closeModal('couponPlayLoader'));

    if (error.response) {
      dispatch({
        type: PLAY_COUPON_FAILURE,
        payload: error.response.data || errorMessage
      });
      dispatch(openModal('playCouponFailureModal'));
    } else {
      dispatch(openModal('couponPlayWaiting'));
    }

    dispatch(updateUserBalance());
  }
};

const createThrottledApiRequest = () => {
  const verifyThrottleTime = EnvironmentManager.getMessageText({ key: 'verify_throttle_time' }) || 300;
  let latestRequest = null;
  let timeoutId = null;
  let isThrottled = false;

  return async (requestData, verifyUrl) => {
    latestRequest = { requestData, verifyUrl };

    if (isThrottled) {
      return new Promise(resolve => {
        if (timeoutId) clearTimeout(timeoutId);
        timeoutId = setTimeout(async () => {
          const response = await axios.post(API_GATEWAY + latestRequest.verifyUrl, latestRequest.requestData);
          isThrottled = false;
          resolve(response);
        }, verifyThrottleTime);
      });
    }

    isThrottled = true;
    setTimeout(() => {
      isThrottled = false;
    }, 300);

    return axios.post(API_GATEWAY + verifyUrl, requestData);
  };
};

const throttledApiRequest = createThrottledApiRequest();

export const validateBetSlip = (wsUpdated = false) => async (dispatch, getState) => {

  const couponDetails = getState().betSlip.couponDetails;
  const isLive = couponDetails.some(coupon => coupon.isLive);

  try {
    dispatch({
      type: VALIDATE_BETSLIP_REQUEST,
      wsUpdated
    });
    let requestData = omit(getState().betSlip.coupon, ['canPlayMultipleCoupons', 'multiCouponCount']);

    const authData = getState().auth;

    const verifyUrl = authData.isAuthenticated ? '/iddaa/verify/customer/v2' : '/iddaa/verify/v2';

    if (!requestData.availableSystems.length) {
      requestData.bets.forEach(() => {
        const maxSystemCount = maxBy(requestData.system, selectedSystemValue => selectedSystemValue);
        if (maxSystemCount > requestData.bets.length) {
          remove(requestData.system, selectedSystemValue => selectedSystemValue === maxSystemCount);
        } else if (!requestData.system.length) {
          requestData.system = [requestData.bets.length];
        }
      });
    }

    const res = await throttledApiRequest(requestData, verifyUrl);
    dispatch({
      type: VALIDATE_BETSLIP_SUCCESS,
      payload: { ...res.data, source: requestData?.source, sourceCouponId: requestData?.source === 'RECOMMENDED_COUPON' ? requestData?.sourceCouponId : '', isRecommendedValid: requestData?.source === 'RECOMMENDED_COUPON' }
    });

    if (LocalStorage.get('betSlipToggler') && LocalStorage.get('betSlipTogglerWithClick') === 'click') {
      const { coupon, couponDetails = [] } = getState().betSlip;

      const validatedCoupon = {
        currency: 'TRY',
        couponCost: coupon?.couponCost,
        totalOdd: res.data?.totalOdd,
        multiplier: coupon?.multiplier,
        system: coupon?.system?.join(','),
        expectedWinAmount: res.data?.expectedWinAmount,
        coupon: coupon?.sourceCouponId,
        affiliation: coupon?.source,
        multiple_coupon_count: coupon?.couponCount
      };
      const analyticOdds = couponDetails.map(couponDetail => {
        const [bet] = couponDetail?.bets ?? [];

        return {
          eventId: couponDetail?.eventId,
          eventName: couponDetail?.name,
          eventStartDate: couponDetail?.eventStartDate,
          marketName: bet?.marketName,
          betType: bet?.betType,
          mbs: bet?.mbs,
          sportType: GTA_SPORT_TYPE_NAMING[couponDetail?.sportType],
          eventLeague: couponDetail?.leagueName,
          oddValue: +bet?.odd,
          isBanker: bet?.banker,
          isLive: couponDetail?.isLive,
          startTime: couponDetail?.startTime
        };
      });

      trackBetSlipViewed({ coupon, analyticOdds, validatedCoupon });
    }

    isLive && dispatch(getEventScores(requestData.bets));

  } catch (e) {
    dispatch({
      type: VALIDATE_BETSLIP_FAILURE,
      payload: e?.response?.data
    });
  }
};

export const saveCoupon = () => async (dispatch, getState) => {
  try {

    const couponData = getState().betSlip.coupon;
    const isLongTermCoupon = couponData?.bets?.some(bet => bet.outright);

    dispatch({
      type: SAVE_COUPON_REQUEST
    });

    const res = await axios.post(API_GATEWAY + '/iddaa/coupons/saved', {
      ...couponData
    });

    dispatch({
      type: SAVE_COUPON_SUCCESS,
      payload: res.data
    });

    dispatch(openModal('saveCouponSuccessModal', { isLongTermCoupon }));

  } catch (error) {

    dispatch({
      type: SAVE_COUPON_FAILURE,
      payload: error.response && error.response.data || errorMessage
    });
    dispatch(openModal('saveCouponFailureModal'));

  }
};

export const betSlipOpened = () => ({
  type: BETSLIP_OPENED
});

export const betSlipClosed = () => ({
  type: BETSLIP_CLOSED
});

export const betSlipSettingsOpened = () => ({
  type: BETSLIP_SETTINGS_OPENED
});

export const betSlipSettingsUpdated = settings => ({
  type: BETSLIP_SETTINGS_UPDATED,
  payload: settings
});

export const toggleBetSlipBanker = (eventId, marketId, marketOutcomeNo) => (dispatch, getState) => {
  dispatch({
    type: TOGGLE_BETSLIP_BANKER,
    payload: { eventId, marketId, marketOutcomeNo }
  });

  const { isMBSValid, coupon: { system, bets } } = getState().betSlip;
  const bankerCount = bets.filter(b => b.banker).length;

  if (bankerCount === system[0]) {
    dispatch(setBetSlipSystem([...system, bets.length]));
  }

  if (isMBSValid) {
    dispatch(validateBetSlip());
  }
};

const getOddDetailParams = odds => {
  let qParams = '';
  odds.forEach(odd => qParams += `e=${odd.eventId}:${odd.marketId}:${odd.outcomeNo}&`);
  return qParams.substring(0, qParams.length - 1);
};

export const addEventVerify = ({ event, writerName = '', selectedOdd, bringedCouponRow, tabName, probabilityLevel }) => async dispatch => {
  let simpleOdds;

  if (selectedOdd) {
    simpleOdds = [{
      eventId: event.id || event.eventId,
      marketId: selectedOdd.mrId || selectedOdd.marketId,
      outcomeNo: selectedOdd.ocn || selectedOdd.marketOutcomeNo
    }];
  } else {
    const eventList = [event];
    simpleOdds = eventList.map(({ eventId, marketId, marketOutcomeNo: outcomeNo }) => ({
      eventId,
      marketId,
      outcomeNo
    }));
  }

  const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?${getOddDetailParams(simpleOdds)}`);

  const newEvent = response.data.events[0];

  dispatch(addEventToBetSlip({
    event: newEvent,
    selectedOdd: newEvent?.odd,
    writerName,
    bringedCouponRow,
    tabName,
    probabilityLevel,
  }));
};

const getOddDetailParamsRecommended = odds => {
  let qParams = '';
  odds.forEach(odd => qParams += `e=${odd.eventId}:${odd.marketId}:${odd.marketOutcomeId || odd?.marketOutcomeNo}&`);
  return qParams.substring(0, qParams.length - 1);
};

export const addEventVerifyRecommended = ({ eventId, event, sourceCouponId, writerName, recommendedCost, recommendedMultiCouponCount }) => async (dispatch, getState) => {
  const eventList = [event];
  const simpleOdds = eventList.map(({ marketId, marketOutcomeId, marketOutcomeNo }) => ({
    eventId,
    marketId,
    marketOutcomeId,
    marketOutcomeNo
  }));
  const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?${getOddDetailParamsRecommended(simpleOdds)}`);
  const newEvent = response.data.events[0];

  dispatch(addEventToBetSlip(
    { event: newEvent, selectedOdd: newEvent?.odd, source: 'RECOMMENDED_COUPON', sourceCouponId: sourceCouponId, writerName: writerName, recommendedCost: recommendedCost, recommendedMultiCouponCount: recommendedMultiCouponCount }));
};

export const addEventToBetSlip = ({ event, selectedOdd, tabName = '', source = '', sourceCouponId = '', writerName = '', recommendedCost, recommendedMultiCouponCount, bringedCouponRow, probabilityLevel }) => (dispatch, getState) => {
  const authors_closed_bet_toaster_message = EnvironmentManager.getMessageText({ key: 'authors_closed_bet_toaster_message' }) || 'Bu bahis Merkezi Bahis Sistemi tarafından kapatıldı. Farklı bir bahis seçebilirsin.';

  if (isEmpty(event) || !selectedOdd) {
    return  toast(
      <ToastTemplate type="gray">
        { authors_closed_bet_toaster_message }
      </ToastTemplate>,
      {
        toastId: 'authorsClosedBetToast',
        autoClose: 5000,
        position: 'bottom-center'
      }
    );
  }


  const isLive = event[EVENT_FIELD_MAPPING.bettingPhase] === 1;

  const payload = {
    event: {
      odds: selectedOdd[ODD_FIELD_MAPPING.value],
      topWinOdds: selectedOdd[ODD_FIELD_MAPPING?.topWinValue],
      banker: false,
      mbs: selectedOdd[ODD_FIELD_MAPPING.mbs],
      eventId: event.id,
      competitionId: event[EVENT_FIELD_MAPPING.competitionId],
      eventVersion: event[EVENT_FIELD_MAPPING.eventVersion],
      marketId: selectedOdd[ODD_FIELD_MAPPING.marketId],
      marketOutcomeNo: selectedOdd[ODD_FIELD_MAPPING.outcomeNo],
      marketVersion: selectedOdd[ODD_FIELD_MAPPING.marketVersion],
      sportType: event[EVENT_FIELD_MAPPING.sportType],
      id: selectedOdd.id,
      isLive,
      outright: OUTRIGHTS.includes(event[EVENT_FIELD_MAPPING.sportType])
    },
    eventDetails: {
      bets: [{
        isRecommended: !!recommendedCost,
        sourceCouponId: sourceCouponId,
        banker: false, //TODO: parametrik alınacak
        betType: selectedOdd[ODD_FIELD_MAPPING.name],
        odd: selectedOdd[ODD_FIELD_MAPPING.value],
        topWinOdds: selectedOdd[ODD_FIELD_MAPPING?.topWinValue],
        marketId: selectedOdd[ODD_FIELD_MAPPING.marketId],
        marketOutcomeNo: selectedOdd[ODD_FIELD_MAPPING.outcomeNo],
        id: selectedOdd.id,
        marketName: selectedOdd[ODD_FIELD_MAPPING.marketName],
        mbs: selectedOdd[ODD_FIELD_MAPPING.mbs],
        specialOddsType: selectedOdd[ODD_FIELD_MAPPING.specialOddsType],
        specialOddsName: selectedOdd[ODD_FIELD_MAPPING.specialOddsName],
        specialOddsValue: selectedOdd[ODD_FIELD_MAPPING.specialOddsValue]
      }],
      eventId: event.id,
      eventStartDate: event[EVENT_FIELD_MAPPING.eventStartDate],
      marketDescription: selectedOdd[ODD_FIELD_MAPPING.outcomeName],
      bettingStatus: event[EVENT_FIELD_MAPPING.bettingStatus],
      isLive,
      // mbs: event.minSelectionCount,
      leagueName: event[EVENT_FIELD_MAPPING.leagueName],
      name: event[EVENT_FIELD_MAPPING.eventName],
      hasLiveStream: event[EVENT_FIELD_MAPPING.hasLiveStream],
      hasTopWin: event[EVENT_FIELD_MAPPING.hasTopWin],
      channel: event[EVENT_FIELD_MAPPING.channel],
      startDate: event[EVENT_FIELD_MAPPING.startDate],
      startTime: event[EVENT_FIELD_MAPPING.startTime],
      score: event.matchInfo && event.matchInfo.score,
      time: event.matchInfo && event.matchInfo.matchStatus,
      sportType: event[EVENT_FIELD_MAPPING.sportType],
      sourceCouponId: sourceCouponId,
    },
    tabName,
    source: source || SPORTSBOOK,
    writerName: writerName,
    bringedCouponRow,
    probabilityLevel,
  };

  if (getState().betSlip.coupon?.bets?.length > 0 && source === 'RECOMMENDED_COUPON' && writerName !== '') {
    dispatch(openModal('clearAndModal'));
    dispatch(resetBetSlip());
  }
  source === 'RECOMMENDED_COUPON' && dispatch(setBetSlipMultiplier(recommendedCost, false));
  source === 'RECOMMENDED_COUPON' && dispatch(setBetSlipCouponCount(recommendedMultiCouponCount, false));

  dispatch({
    type: ADD_EVENT_TO_BETSLIP_SUCCESS,
    payload: payload
  });
  dispatch(validateMbsState());

  const eventCount = getState().betSlip.coupon?.bets?.length;
  const { acceptLiveEvents, acceptPrematchEvents } = getState().auth.data;

  if (payload.event?.mbs === 1 && eventCount === 1) {
    if ((acceptLiveEvents && isLive) || (acceptPrematchEvents && !isLive)) {
      LocalStorage.set('betSlipToggler', true);
      LocalStorage.set('betSlipTogglerWithClick', null);
      dispatch(betSlipOpened());
    }
  }

  const isMBSValidAfterAdd = getState().betSlip.isMBSValid;

  if (LocalStorage.get('betSlipToggler') && isMBSValidAfterAdd) {
    LocalStorage.set('betSlipTogglerWithClick', null);
    dispatch(validateBetSlip());
  }

};
export const couponsPageCouponValidate = ({ selections, source, ...couponDetails }) => async (dispatch, getState) => {

  const simpleOdds = selections.map(({ eventId, marketId, marketOutcomeNo: outcomeNo }) => ({
    eventId,
    marketId,
    outcomeNo
  }));

  try {
    const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?${getOddDetailParams(simpleOdds)}`);

    const events = response.data.events;

    const oddDetails = events.map(e=>e.odd);

    const isBetSlipFull = getState().betSlip.couponDetails.length > 0;

    if (oddDetails.length === 0) { // maç kalmadıysa
      dispatch(openModal('nonPlayableCouponModal'));
      return;
    }

    if (isBetSlipFull) {
      if (selections.length > oddDetails.length) { // eksik maç ekliyorsam
        dispatch(openModal('useOnNewCouponModal', { data: { events: selections, ...couponDetails, validEvents: events,
          nextModal: () => { // eksik maç ekliyorum ve betslip dolu
            dispatch(openModal('failureSavedCouponModal', { data: { events: selections, ...couponDetails, validEvents: events } }));
          }
        } }));
        return;
      }

      dispatch(openModal('useOnNewCouponModal', { data: { events: selections, ...couponDetails, validEvents: events } }));
      return;
    }

    dispatch(addMultipleEventsToBetSlip({ events: selections, ...couponDetails, source: source }, events));


  } catch (error) {
    //console.log('error', error);
  }
};

export const tribunCouponValidate = (data, clickType) => async (dispatch, getState) => {
  let { coupon } = data;

  const simpleOdds = coupon.selections.map(({ eventId, marketId, marketOutcomeNo: outcomeNo }) => ({
    eventId,
    marketId,
    outcomeNo
  }));

  try {
    const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?${getOddDetailParams(simpleOdds)}`);

    const events = response.data.events;

    getState().betSlip['tribünEventList'] = simpleOdds;

    const oddDetails = events.map(e=>e.odd);

    let tribunMultipleEventCheckModalControl =  simpleOdds?.length > oddDetails?.length; //Betslipe atılamayacak maç var

    const modalData = {
      events: data.coupon.selections,
      couponDetails: data.coupon,
      source: data.user.username,
      sourceId: data.user.userId,
      feedId: data.feedId,
      likeCount: data.likes,
      commentCount: data.comments,
      validEvents: events,
      clickType: clickType
    };
    if (data.coupon.selections.length === 0 || oddDetails?.length === 0) { // hiç maç kalmadı
      dispatch(openModal('tribunNonPlayableCouponModal'));
      return;
    }

    if (getState().betSlip.couponDetails.length > 0) { // betslipte zaten maç varsa
      if (tribunMultipleEventCheckModalControl) { // eksik maç var
        dispatch(openModal('tribunMultipleEventCheckModal', {
          ...modalData,
          nextModal: () => {
            dispatch(openModal('tribunPlayModal', { ...modalData }));
          }
        }));
      } else { // eksik maç yok
        dispatch(openModal('tribunPlayModal', { ...modalData }));
      }
      return;
    }

    if (tribunMultipleEventCheckModalControl) { // betslip boş eksik maç var
      dispatch(openModal('tribunMultipleEventCheckModal', { ...modalData }));
    } else { // direk oyna
      dispatch(addMultipleEventsToBetSlip({ ...modalData }, events));
    }

  } catch (error) {
    //console.log('error', error);
  }
};

export const addMultipleEventsToBetSlip = ({ events: eventList = [], couponDetails, source, sourceId, feedId, likeCount, commentCount }, validEvents) => async (dispatch, getState) => {

  let simpleOdds = eventList.map(({ eventId, marketId, marketOutcomeNo: outcomeNo }) => {
    return {
      eventId,
      marketId,
      outcomeNo
    };
  });
  try {
    let validOddDetails = null;
    let eventDetails = null;

    if (!validEvents?.length) {
      const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?${getOddDetailParams(simpleOdds)}`);
      eventDetails = response.data.events;
      const oddDetails = eventDetails.map(e=>e.odd);
      validOddDetails = map(pickBy(oddDetails, isObject));
    } else {
      eventDetails = validEvents;
      validOddDetails = validEvents.map(e=>e.odd);
    }
    //Tribün özelinde coupon detaytında sistem'in naming'i ve type'ı değişik olduğundan ötürü bunu gerçekleştirmek zorunda kaldık.
    if (couponDetails?.system) {
      couponDetails.systems = couponDetails.system.split(',').map(item => +item);
    }

    const lastData = {
      multiplier: null,
      couponCount: null,
      system: null
    };

    if (couponDetails?.couponType === 'system') {
      lastData.multiplier = 1;
    }

    if (getState().betSlip.addedRebetButton === 'Tekrar Oyna') {
      lastData.multiplier = couponDetails.multiplier;
      lastData.couponCount = couponDetails.childCouponsSize + 1;
    }


    if ( eventDetails.length < simpleOdds.length ) {
      lastData.system = [eventDetails.length];
      lastData.multiplier = getDefaultStakeAmount();
      lastData.couponCount = 1;
      getState().betSlip.addedRebetButton = 'Kupona Ekle';
    } else {
      lastData.system = couponDetails?.systems;
      getState().betSlip.addedRebetButton = 'Oyna';
    }

    const payload = {
      events: validOddDetails.map(oddDetail => {
        const matchedOddDetail = eventList.find(event => {
          return oddDetail.id === `${event.eventId}:${event.marketId}:${event.marketOutcomeNo}`;
        });

        if (!matchedOddDetail) {
          throw new Error('No event detail found');
        }

        const eventDetail = eventDetails.find(e=>e.id === matchedOddDetail.eventId);
        return {
          odds: oddDetail[ODD_FIELD_MAPPING.value],
          topWinOdds: oddDetail[ODD_FIELD_MAPPING.topWinValue],
          banker: matchedOddDetail.banker || false,
          mbs: oddDetail.mbs,
          competitionId: eventDetail?.[EVENT_FIELD_MAPPING.competitionId],
          eventId: matchedOddDetail.eventId,
          eventVersion: matchedOddDetail.eventVersion || eventDetail?.[EVENT_FIELD_MAPPING.eventVersion],
          marketId: matchedOddDetail.marketId,
          marketOutcomeNo: matchedOddDetail.marketOutcomeNo,
          marketVersion: matchedOddDetail.marketVersion || oddDetail[ODD_FIELD_MAPPING.marketVersion],
          sportType: matchedOddDetail.sportType,
          id: `${matchedOddDetail.eventId}:${matchedOddDetail.marketId}:${matchedOddDetail.marketOutcomeNo}`,
          isLive: matchedOddDetail[EVENT_FIELD_MAPPING.bettingPhase] ? matchedOddDetail[EVENT_FIELD_MAPPING.bettingPhase] === 1 :  eventDetail[EVENT_FIELD_MAPPING.bettingPhase] === 1,
          outright: OUTRIGHTS.includes(matchedOddDetail.sportType),
        };
      }),
      details: validOddDetails.map(oddDetail => {
        const matchedOddDetail = eventList.find(event =>
          oddDetail.id === `${event.eventId}:${event.marketId}:${event.marketOutcomeNo}`
        );

        if (!matchedOddDetail) {
          throw new Error('No event detail found');
        }
        const eventDetail = eventDetails.find(e=>e.id === matchedOddDetail.eventId);

        return {
          bets: [{
            banker: matchedOddDetail.banker || false,
            betType: matchedOddDetail.marketOutcomeName,
            odd: oddDetail[ODD_FIELD_MAPPING.value],
            topWinOdds: oddDetail[ODD_FIELD_MAPPING.topWinValue],
            marketId: matchedOddDetail.marketId,
            marketOutcomeNo: matchedOddDetail.marketOutcomeNo,
            id: `${matchedOddDetail.eventId}:${matchedOddDetail.marketId}:${matchedOddDetail.marketOutcomeNo}`,
            marketName: matchedOddDetail.marketName,
            mbs: oddDetail.mbs,
            specialOddsType: oddDetail[ODD_FIELD_MAPPING.specialOddsType],
            specialOddsName: oddDetail[ODD_FIELD_MAPPING.specialOddsName],
            specialOddsValue: oddDetail[ODD_FIELD_MAPPING.specialOddsValue]
          }],
          eventId: matchedOddDetail.eventId,
          bettingStatus: eventDetail?.[EVENT_FIELD_MAPPING.bettingStatus],
          isLive: matchedOddDetail[EVENT_FIELD_MAPPING.bettingPhase] ? matchedOddDetail[EVENT_FIELD_MAPPING.bettingPhase] === 1 :  eventDetail[EVENT_FIELD_MAPPING.bettingPhase] === 1,
          // mbs: matchedOddDetail.mbs,
          leagueName: eventDetail?.[EVENT_FIELD_MAPPING.leagueName],
          name: matchedOddDetail.eventName,
          hasLiveStream: eventDetail?.[EVENT_FIELD_MAPPING.hasLiveStream] || 0,
          eventDate: matchedOddDetail.eventDate,
          startDate: eventDetail?.[EVENT_FIELD_MAPPING.startDate],
          startTime: eventDetail?.[EVENT_FIELD_MAPPING.startTime],
          sportType: matchedOddDetail.sportType
        };
      }),
      source,
      sourceId,
      feedId,
      likeCount,
      commentCount,
      couponDetails,
      sourceCouponId: couponDetails?.couponId,
      forceSystem: lastData.system,
    };

    dispatch({ type: ADD_MULTIPLE_EVENTS_TO_BETSLIP, payload: payload });
    dispatch(validateMbsState());


    lastData.multiplier ? dispatch(setBetSlipMultiplier(lastData.multiplier, false)) : null;
    lastData.couponCount ? dispatch(setBetSlipCouponCount(lastData.couponCount, false)) : null;

    dispatch(closeModal('tribunMultipleEventCheckModal'));
    dispatch(closeModal('useOnNewCouponModal'));

    const isMBSValidAfterAdd = getState().betSlip.isMBSValid;
    if (isMBSValidAfterAdd) {
      dispatch(validateBetSlip());
    }

    dispatch(betSlipOpened());

    // Added For Click Rebet Mix Panel
    setTimeout(() => {
      dispatch({
        type: ADD_MULTIPLE_EVENTS_TO_BETSLIP_SUCCESS,
        payload: payload
      });
    }, 750);


  } catch (e) {
    //console.log('error', e);
  }

};

export const removeEventFromBetSlip = (oddId, skipSetLastRemovedBet = false) => (dispatch, getState) => {
  const state = getState().betSlip;
  const removedCouponDetail = state.couponDetails.find(cd =>
    cd.bets.some(bet => bet.id === oddId)
  );

  dispatch({
    type: ADD_EVENT_TO_BETSLIP_FAILURE,
    toastMessage: null
  });

  dispatch({
    type: REMOVE_EVENT_FROM_BETSLIP,
    payload: { oddId, skipSetLastRemovedBet }
  });

  if (removedCouponDetail && !skipSetLastRemovedBet) {
    dispatch({
      type: 'SET_LAST_REMOVED_BET',
      payload: removedCouponDetail
    });
  }

  dispatch(validateMbsState());

  const couponAfterRemoval = getState().betSlip.coupon;
  const isMBSValidAfterRemoval = getState().betSlip.isMBSValid;
  const isBetsEmpty = couponAfterRemoval.bets.length === 0;
  const tribünEventList = getState().betSlip.tribünEventList;
  if (tribünEventList?.length > 0) {
    const eventId = oddId && parseInt(oddId.split(':')[0]);
    const marketId = oddId && parseInt(oddId.split(':')[1]);
    const outcomeNo = oddId && parseInt(oddId.split(':')[2]);
    const selectedOddTribün = tribünEventList.find(item=>item.eventId === eventId && item.marketId === marketId && item.outcomeNo === outcomeNo );
    const index = tribünEventList.indexOf(selectedOddTribün);
    if (tribünEventList[index])
      tribünEventList.splice(index, 1);
  }

  if (LocalStorage.get('betSlipToggler') && !isBetsEmpty && isMBSValidAfterRemoval) {
    dispatch(validateBetSlip());
  }
};

let lastRequestController = null;
// eslint-disable-next-line no-unused-vars
let lastPayload = null;
let isProcessing = false;

const computePredictaAPI = async (payload, requestId) => {
  if (lastRequestController) {
    lastRequestController.abort();
  }

  lastRequestController = new AbortController();
  const { signal } = lastRequestController;

  try {
    const response = await axios.post(
      `${API_GATEWAY}/v3/mobile/aggregator/predicta/compute`,
      payload,
      { signal }
    );

    if (!response || !response.data) {
      return { calculatedProbability: null };
    }

    return response.data;
  } catch (error) {
    return { calculatedProbability: null };
  }
};

const debounceComputePredicta = (() => {
  const debounced = debounce(
    async (payload, requestId, resolve) => {
      isProcessing = true;
      const result = await computePredictaAPI(payload, requestId);
      isProcessing = false;
      resolve(result);
    },
    300,
    { leading: false, trailing: true }
  );

  return (payload, requestId) => {
    return new Promise(resolve => {
      if (!isProcessing) {
        lastPayload = payload;
        debounced(payload, requestId, resolve);
      }
    });
  };
})();

export const computePredicta = payload => async dispatch => {
  if (!payload.system || payload.system.length === 0 || payload.system.includes(0)) {
    return null;
  }

  if (LocalStorage.get('betSlipToggler')) {
    const latestRequestId = Date.now();
    try {
      dispatch({ type: 'PREDICTA_COMPUTE_REQUEST' });

      const resultPromise = debounceComputePredicta(payload, latestRequestId);
      const result = await resultPromise;

      if (!result || typeof result !== 'object') {
        return null;
      }

      dispatch({ type: 'PREDICTA_COMPUTE_SUCCESS', payload: result, requestId: latestRequestId });

      return result;
    } catch (error) {
      dispatch({ type: 'PREDICTA_COMPUTE_FAILURE', error, requestId: latestRequestId });
      return null;
    }
  }

  return null;
};

export const undoLastRemovedBet = () => async (dispatch, getState) => {
  const { betSlip } = getState();
  const lastRemoved = betSlip.lastRemovedBet;
  if (!lastRemoved) return;

  const selectedOdd = lastRemoved.bets && lastRemoved.bets[0];
  if (!selectedOdd) return;

  try {
    const response = await axios.get(`${API_GATEWAY}/v3/mobile/aggregator/gamelist/events/odd/details?e=${lastRemoved.eventId}:${selectedOdd.marketId}:${selectedOdd.marketOutcomeNo}`);

    if (!response?.data?.events?.length) {
      toast(
        <ToastTemplate type="gray">
          { EnvironmentManager.getMessageText({ key: 'authors_closed_bet_toaster_message' }) || 'Bu bahis Merkezi Bahis Sistemi tarafından kapatıldı. Farklı bir bahis seçebilirsin.' }
        </ToastTemplate>,
        {
          toastId: 'authorsClosedBetToast',
          autoClose: 5000,
          position: 'bottom-center'
        }
      );

      dispatch({ type: 'SET_LAST_REMOVED_BET', payload: null });
      return;
    }

    const currentEvent = response.data.events[0];
    const currentOdd = currentEvent.odd;

    if (!currentOdd || currentOdd.mrs === -1 || currentOdd.mrs === 0) {
      toast(
        <ToastTemplate type="gray">
          { EnvironmentManager.getMessageText({ key: 'authors_closed_bet_toaster_message' }) || 'Bu bahis Merkezi Bahis Sistemi tarafından kapatıldı. Farklı bir bahis seçebilirsin.' }
        </ToastTemplate>,
        {
          toastId: 'authorsClosedBetToast',
          autoClose: 5000,
          position: 'bottom-center'
        }
      );

      dispatch({ type: 'SET_LAST_REMOVED_BET', payload: null });
      return;
    }

    dispatch({
      type: BETSLIP_EVENT_BETTING_WS_STATUS_TOGGLE,
      payload: {
        eventId: lastRemoved.eventId,
        wsBettingStatus: currentEvent.bs
      }
    });

    const payload = {
      event: {
        odds: currentOdd.val,
        topWinOdds: currentOdd.tval,
        banker: false,
        mbs: currentOdd.mbs,
        eventId: lastRemoved.eventId,
        competitionId: lastRemoved.competitionId || null,
        eventVersion: currentEvent.ev || 0,
        marketId: selectedOdd.marketId,
        marketOutcomeNo: selectedOdd.marketOutcomeNo,
        marketVersion: currentOdd.mrv || 0,
        sportType: lastRemoved.sportType,
        id: selectedOdd.id,
        isLive: lastRemoved.isLive,
        outright: OUTRIGHTS.includes(lastRemoved.sportType)
      },
      eventDetails: {
        ...lastRemoved,
        bets: [{
          ...lastRemoved.bets[0],
          odd: currentOdd.val,
          topWinOdds: currentOdd.tval,
          mrs: currentOdd.mrs
        }]
      },
      tabName: '',
      source: betSlip.coupon.source || SPORTSBOOK,
      writerName: '',
      isUndo: true
    };

    dispatch({
      type: ADD_EVENT_TO_BETSLIP_SUCCESS,
      payload: payload
    });

    dispatch(validateMbsState());

    dispatch({ type: 'SET_LAST_REMOVED_BET', payload: null });

    dispatch({
      type: 'UNDO_BET_STATUS',
      payload: { success: true }
    });

    dispatch(validateBetSlip());

  } catch (error) {
    dispatch({
      type: 'UNDO_BET_STATUS',
      payload: { success: false, reason: 'ERROR' }
    });
  }
};

export const setBetSlipMultiplier = (multiplier, validate = true) => (dispatch, getState) => {
  dispatch({ type: SET_BETSLIP_MULTIPLIER, payload: multiplier });

  const { isMBSValid } = getState().betSlip;
  if (isMBSValid && validate) {
    return dispatch(validateBetSlip());
  }
  return Promise.resolve();
};

export const syncBetSlipMinStake = () => (dispatch, getState) => {
  const { coupon } = getState().betSlip;
  const { min } = getDefaultStakeLimits();
  const newDefaultStake = getDefaultStakeAmount();
  const lastAppliedDefaultStake = getLastAppliedDefaultStake();
  const multiplier = +coupon?.multiplier;
  const betCount = coupon?.bets?.length || 0;
  const isCombineCoupon = !betCount || (coupon?.system?.length === 1 && coupon.system.includes(betCount));

  setLastAppliedDefaultStake(newDefaultStake);

  if (!isCombineCoupon) return Promise.resolve();

  const isFollowingDefaultStake = lastAppliedDefaultStake !== null && multiplier === +lastAppliedDefaultStake;

  if (isFollowingDefaultStake && multiplier !== newDefaultStake) {
    return dispatch(setBetSlipMultiplier(newDefaultStake));
  }

  if (multiplier < min) {
    return dispatch(setBetSlipMultiplier(min));
  }

  return Promise.resolve();
};

export const setBetSlipCouponCount = (couponCount, validate = true) => (dispatch, getState) => {
  dispatch({ type: SET_BETSLIP_COUPON_COUNT, payload: couponCount || 1 });

  const { isMBSValid } = getState().betSlip;
  if (isMBSValid && validate) {
    return dispatch(validateBetSlip());
  }
  return Promise.resolve();
};

export const setBetSlipSystem = system => (dispatch, getState) => {
  dispatch({
    type: SET_BETSLIP_SYSTEM,
    payload: system
  });

  const { isMBSValid } = getState().betSlip;
  if (isMBSValid) {
    dispatch(validateBetSlip());
  }
};

export const validateMbsState = () => dispatch => {
  dispatch({
    type: VALIDATE_MBS_STATE
  });
};

export const resetBetSlip = () => dispatch => {
  dispatch({
    type: RESET_BETSLIP
  });
};

export const resetPlayCoupon = () => dispatch => {
  dispatch({
    type: RESET_PLAY_COUPON
  });
};

export const addEventToBetSlipToastMessageReset = () => dispatch => {
  dispatch({
    type: ADD_EVENT_TO_BETSLIP_TOAST_MESSAGE_RESET
  });
};

export const setMultipleCouponData = data => ({
  type: SET_MULTIPLE_COUPON_DATA,
  payload: data,
});

const _openPlaySuccessModal = ({ dispatch, isMultipleCoupon, title = '', type = 'success', icon = 'svgSuccessPageSuccess', couponStatus = [], sourceCoupon, hasInfoPopUpShown, couponId }) => {
  dispatch(closeModal('couponPlayLoader'));
  if (isMultipleCoupon) {
    dispatch(setMultipleCouponData({ HeaderTitle: title, HeaderType: type, HeaderIcon: icon, couponStatus, isMultipleCoupon }));
    History.push('/kupon-ozet');
  } else {
    History.push('/kupon-ozet');
  }
  dispatch(updateUserBalance());
};
